export default "__VITE_PUBLIC_ASSET__5b232b7c__"